import { combineReducers } from 'redux';

import { OCCUPANCY_SLICE_NAME, occupancyReducer } from '../../modules/occupancy/reducer';
import { featureFlagService } from '../../services/featureFlagService/reducer';
import { SPACE_CATEGORIES_VIEW_SLICE_NAME, spaceCategoriesViewReducer } from '../../views/spaceCategories/reducer';

export const views = combineReducers({
    featureFlagService,
    [OCCUPANCY_SLICE_NAME]: occupancyReducer,
    [SPACE_CATEGORIES_VIEW_SLICE_NAME]: spaceCategoriesViewReducer,
});
